import React from 'react';
import { ArrowRightIcon, CheckIcon, StarIcon } from 'lucide-react';
import { Section } from './Section';
import { CtaButton } from './CtaButton';
import { TrustRow } from './TrustRow';
import { volumes, insideEveryVolume } from '../data/volumes';
export function Volumes() {
  return <Section background="white" labelledBy="volumes-heading" data-id="element-277" data-mp="1c5788ndsh702">
      <h2 id="volumes-heading" className="mx-auto max-w-3xl text-center font-serif text-3xl font-semibold leading-[1.15] text-ink sm:text-[44px]" data-id="element-278" data-mp="1c3e3jdmqkwup">
        Six volumes. One decision system. Zero freezing.
      </h2>

      <ol className="mt-14 space-y-5" data-id="element-279" data-mp="1quwe2vwttz6o">
        {volumes.map(volume => <li key={volume.number} className="grid grid-cols-1 gap-5 rounded-2xl border border-sage/15 bg-paper p-6 shadow-card sm:grid-cols-[auto_1fr] sm:gap-8 sm:p-8" data-id="element-280" data-mp="1vtg2d2yw7n27">
            <p className="font-serif text-4xl font-semibold leading-none text-sage/35 sm:text-5xl" data-id="element-281" data-mp="keayvwqxtkhj">
              {volume.number}
            </p>

            <div data-id="element-282" data-mp="3o8y90xg1ofmq">
              <div className="flex flex-wrap items-center gap-x-3 gap-y-2" data-id="element-283" data-mp="3o8eza40jsxjs">
                <h3 className="font-serif text-2xl font-semibold leading-tight text-ink sm:text-[28px]" data-id="element-284" data-mp="3jadhrnirt6af">
                  {volume.title}
                </h3>
                {volume.flag && <span className="inline-flex items-center gap-1.5 rounded-full bg-brass/12 px-3 py-1 font-sans text-[11px] font-semibold uppercase tracking-[0.12em] text-brass" data-id="element-285" data-mp="3t688l5x5e7oa">
                    <StarIcon className="h-3 w-3 fill-brass" strokeWidth={0} aria-hidden="true" data-id="element-286" data-mp="63brucn409g7" />
                    {volume.flag}
                  </span>}
              </div>

              {volume.subtitle && <p className="mt-2 font-sans text-[13px] font-semibold uppercase tracking-[0.1em] text-brass" data-id="element-287" data-mp="fsvc9mqh0bd6">
                  {volume.subtitle}
                </p>}

              <p className="mt-3 font-sans text-[16px] leading-[1.65] text-ink-soft" data-id="element-288" data-mp="prki2h53e5d2">
                {volume.body}
              </p>

              <p className="mt-5 flex items-start gap-2 font-sans text-[15px] font-semibold leading-snug text-sage" data-id="element-289" data-mp="wrmqfrw3uvmu">
                <ArrowRightIcon className="mt-0.5 h-4 w-4 shrink-0" strokeWidth={2} aria-hidden="true" data-id="element-290" data-mp="16rx4tftvm93l" />
                {volume.result}
              </p>
            </div>
          </li>)}
      </ol>

      <div className="mt-10 rounded-2xl bg-sage-soft p-6 sm:p-8" data-id="element-291" data-mp="1fjyz0wdcqt5f">
        <h3 className="font-sans text-[12px] font-semibold uppercase tracking-[0.14em] text-sage" data-id="element-292" data-mp="1kiaebmmf1vv1">
          Inside every volume
        </h3>
        <ul className="mt-5 grid grid-cols-1 gap-x-8 gap-y-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-293" data-mp="1pgbxs8nr7x71">
          {insideEveryVolume.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-294" data-mp="3rajho9pyuxp4">
              <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-sage" strokeWidth={2.25} aria-hidden="true" data-id="element-295" data-mp="3rc49vsot64jt" />
              <span className="font-sans text-[15px] leading-snug text-ink-soft" data-id="element-296" data-mp="2df1c0lzasa4g">{item}</span>
            </li>)}
        </ul>
      </div>

      <div className="mt-14 flex flex-col items-center" data-id="element-297" data-mp="24l6g84k2fw1h">
        <CtaButton href="#pricing" data-id="element-298" data-mp="24loet7u7amck">I want the complete system</CtaButton>
        <TrustRow className="mt-4 justify-center" data-id="element-299" data-mp="1znmsme1ha6wv" />
      </div>
    </Section>;
}